// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__WvsZb","contactCard":"Contact_contactCard__3zBQ5","directions":"Contact_directions__EV8A9"};